import {
  IProvidedTranslationProps,
  withTranslations,
} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';
import classNames from 'classnames';
import React from 'react';
import {Button, ButtonSize, HoverStyles} from '@wix/wix-ui-tpa/cssVars';
import {ProvidedGlobalProps, withGlobalProps} from '../../../providers/globalPropsProvider';
import {useIsStickyButton} from '../../../providers/renderContext';
import {classes as buyNowButtonStyles} from '../BuyNowButton/BuyNowButton.st.css';
import productPageButtonsContainerStyles from '../ProductPageButtonsContainer.scss';

export interface SubscribeButtonProps extends ProvidedGlobalProps, IProvidedTranslationProps {
  productInStock: boolean;
  isStickyButton: boolean;
}

export enum SubscribeButtonDataHook {
  Root = 'subscribe-button',
}

class SubscribeButtonComponent extends React.Component<SubscribeButtonProps> {
  public render(): JSX.Element {
    const {
      t,
      productInStock,
      isStickyButton,
      globals: {product, selectedVariant, shouldShowWishlistButton, handleSubscribe, accessibilityEnabled},
    } = this.props;
    const {price} = selectedVariant || product;

    const disabled = !productInStock || price <= 0;
    let caption = t('PRODUCT_PAGE_SUBSCRIBE_NOW_BUTTON');

    if (disabled) {
      caption =
        /* istanbul ignore next: todo: test */ price > 0 || !productInStock
          ? t('PRODUCT_OUT_OF_STOCK_BUTTON')
          : t('ADD_TO_CART_BUTTON_PRICE_ZERO');
    }

    const buttonClasses = classNames(buyNowButtonStyles.buyNowButton, productPageButtonsContainerStyles.fullWidth, {
      [productPageButtonsContainerStyles.primaryButton]: shouldShowWishlistButton,
    });

    return (
      <Button
        hoverStyle={HoverStyles.underline}
        data-wix-hideable={true}
        type="button"
        onClick={() => handleSubscribe(accessibilityEnabled, isStickyButton)}
        disabled={disabled}
        data-hook={SubscribeButtonDataHook.Root}
        className={buttonClasses}
        size={ButtonSize.large}
        fullWidth={!shouldShowWishlistButton}>
        {caption}
      </Button>
    );
  }
}

const SubscribeButtonWithIsStickyButton: React.FC<Omit<SubscribeButtonProps, 'isStickyButton'>> = (props) => {
  const isStickyButton = useIsStickyButton();
  return <SubscribeButtonComponent {...(props as SubscribeButtonProps)} isStickyButton={isStickyButton} />;
};

export const SubscribeButton = withGlobalProps(withTranslations('globals.texts')(SubscribeButtonWithIsStickyButton));
